import React from "react";
import { Tag } from "antd";

const WarningStatus = ({ status }) => {
  const getStatusConfig = (status) => {
    const config = {
      pending: { color: "orange", text: "En attente" },
      finalized: { color: "green", text: "Infraction confirmée" },
      canceled: { color: "red", text: "Annulée" },
    };
    return config[status] || { color: "default", text: status };
  };

  const { color, text } = getStatusConfig(status);
  return <Tag color={color}>{text}</Tag>;
};

export default WarningStatus;
